import { type FC, type ReactNode } from "react";
import { type SerializedStyles, css, keyframes } from "@emotion/react";
import { Box } from "@/components/essentials/box";

export interface FadeableBoxProps {
  readonly fadeInCondition: boolean;
  readonly isAlwaysDisplay?: boolean;
  readonly children?: ReactNode;
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeInStyle = (props: { isFadeIn: boolean }): SerializedStyles => css`
  animation: ${
    props.isFadeIn
      ? css`
        ${fadeIn} .5s ease-out forwards
      `
      : "none"
  };
`;

export const FadeableBox: FC<FadeableBoxProps> = ({ fadeInCondition, isAlwaysDisplay = false, children }) => {
  return (
    <>
      {(isAlwaysDisplay || fadeInCondition) && <Box css={fadeInStyle({ isFadeIn: !isAlwaysDisplay })}>{children}</Box>}
    </>
  );
};
